import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import StyledImage from "./styled-image"
import Cta from "./cta"
import Carousel from "./carousel"
import HoursTable from "./hours-table"
import { kebabCase } from "lodash"

export default function DiningRoll({ props, isDiningPage = false }) {
  const pageUri = props?.uri
  const format = isDiningPage ? null : props?.options?.format
  const diningList = isDiningPage ? null : props?.diningList
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo5OA==" }) {
        diningOptions {
          diningOptions {
            otherDiningOptionsHeading
            description
            diningCta {
              target
              title
              url
            }
          }
        }
      } 
      allWpDining {
        nodes {
          ...DiningCard
        }
      }
    }
  `)
  const diningNodes = !isDiningPage ? diningList?.filter(node => node?.uri !== pageUri) : data?.allWpDining.nodes?.filter(node => node?.uri !== pageUri && node?.dining?.card?.showWithinPopularRestaurantsSections)
  const options = data?.wpOption?.diningOptions?.diningOptions
  const heading = !isDiningPage ? props.heading : options?.otherDiningOptionsHeading
  const cta = !isDiningPage ? props.cta : options?.diningCta
  const content = !isDiningPage ? props.content : options?.description
  const carouselSettingsOverrides = {
    slidesToShow: 1,
    slidesToScroll: 1,
    className: `slick-arrows-centered slick-arrows-wide -mx-[1px]`,
  }
  return (

    <div className="container py-10" id="dining-options">
      <div className="mb-10 md:text-center max-w-5xl mx-auto">
        {heading ? <h2 id={kebabCase(heading)} className="mb-4 ">{heading}</h2> : null}
        {content ? <div
          className={`parsed-content mb-2`}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        /> : null}
      </div>
      {diningNodes ?
        <>
          <div className="md:hidden mb-6">
            <Carousel settingsOverrides={carouselSettingsOverrides}>
              {diningNodes.map((dining, index) => {
                return (
                  <DiningDetails props={dining} key={index} format={format} />
                )
              })
              }
            </Carousel>
          </div>

          <ul className={`hidden md:grid md:grid-cols-2 ${format === "compact" ? "lg:grid-cols-3" : ""} gap-8 lg:gap-12 xl:gap-x-20 2xl:gap-x-24 mb-10`}>
            {diningNodes.map((dining, index) => {
              return (
                <li key={index}>
                  <DiningDetails props={dining} format={format} />
                </li>
              )
            })
            }
          </ul>
        </> : null}
      {cta?.url ?
        <div className="text-center mb-4">
          <Cta props={cta} arrow={true} />
        </div> : null}
    </div>
  )
}
const DiningDetails = ({ props, format }) => {
  const { title, uri, excerpt, featuredImage } = props
  const image = featuredImage?.node
  const { card, hours } = props?.dining
  const hoursOverride = card?.overrideHours ? { hoursDetails: card.overrideHours } : null
  const hoursHidden = card?.hideHours
  const cta = {
    title: card?.buttonTitle,
    url: uri,
  }
  return (

    <div className={`mx-auto md:mx-0 ${format === "compact" ? "max-w-sm" : "max-w-md"} md:max-w-none`}>
      {image ? (
        <div
          className={`print:max-w-sm flex justify-center block-img relative w-full aspect-video`}
        >
          {cta?.url ?
            <Link to={cta.url} className="block">
              <StyledImage
                image={image}
                objectFit="cover"
                className={`w-full aspect-video`} />
            </Link>
            : <StyledImage
              image={image}
              objectFit="cover"
              className={`w-full aspect-video`} />}
        </div>
      ) : null}


      <div className={`flex-grow self-stretch w-5/6 sm:w-11/12 mx-auto bg-white sm:shadow-spread shadow-spread-xs ${image ? "-mt-4" : ""} py-4 px-5 relative rounded flex-grow`}>
        {title ? <h3 className='h3-lg mb-2'>
          {cta?.url ?
            <Link to={cta.url} className="text-body">
              {title}
            </Link>
            : title}
        </h3> : null}
        {excerpt && (
          <div className="mb-2 text-sm sm:text-base parsed-content">
            <div
              dangerouslySetInnerHTML={{
                __html: excerpt,
              }}
            />
          </div>
        )}
        {hours && !hoursHidden && format !== "compact" ?
          <HoursTable props={hoursOverride || hours[0]} includeHeading={hours.length > 1} />
          : null
        }
        <Cta props={cta} arrow={format !== "compact"} />
      </div>
    </div>
  )
}
